import { useNavigate } from 'react-router-dom';
import { GovLayout, GovLayoutColumn } from '@gov-design-system-ce/react';
import { useCmsFaqCategoriesQuery } from '@gov-nx/api';
import { useLocale } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { Button, LayoutGap, SectionHeader } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';
import { CmsFaqTabs } from '../../Cms/CmsFaqTabs';

export const HomepageFaqSection = () => {
	const cmsFaqCategories = useCmsFaqCategoriesQuery();
	const code = PageCode['rozcestnik'];
	const { t } = useLocale(code);
	const navigate = useNavigate();

	return (
		<section aria-labelledby="titulek-casto-se-ptate">
			<LayoutGap gap="l">
				<SectionHeader
					id="titulek-casto-se-ptate"
					headline={t('casto-se-ptate')}>
					<Button
						color="primary"
						size="s"
						type="base"
						aria-label={t('akce.wcag.zobrazit-vse-faq')}
						onClick={() => navigate(pageRouteResolver('casto-se-ptate'))}>
						{t('akce.zobrazit-vse')}
					</Button>
				</SectionHeader>
				<GovLayout
					type="text"
					variant="left">
					<GovLayoutColumn>
						{cmsFaqCategories.data.length > 0 && (
							<CmsFaqTabs
								faqCategories={cmsFaqCategories.data}
								maxFaqPerTab={10}
								isLoading={cmsFaqCategories.isLoading}
								tabsType="chip"
							/>
						)}
					</GovLayoutColumn>
				</GovLayout>
			</LayoutGap>
		</section>
	);
};
